import React, { useState, useEffect } from "react";
import axios from "axios";

import { Link, useParams } from "react-router-dom";

import Spinner from "./Spinner/Spinner"
import QuotesList from "./QuotesList";

const Authors = () => {
  const [allAuthors, setAllAuthors] = useState([]);

  const [quotes, setQuotes] = useState([]);
  const [total, setTotal] = useState(null);
  const [totalPages, setTotalPages] = useState(null);
  const [perPage, setPerPage] = useState(null);
  const [currentPage, setCurrentPage] = useState(null);

  const [loading, setLoading] = useState(false);

  const fetchAuthors = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_STOIC_AUTHORS}`
      );
      setAllAuthors(response.data.map(a => a.author));
      setLoading(false);
    } catch (error) {
      return error;
    }
  };

  const fetchQuotes = async (pageNumber) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_STOIC_SEARCH}/${query}?page=${pageNumber}&limit=18`
      );
      setQuotes(response.data.results);
      setTotal(response.data.total_results);
      setTotalPages(response.data.total_pages);
      setPerPage(response.data.per_page);
      setCurrentPage(response.data.page);
      setLoading(false);
    } catch (error) {
      return error;
    }
  };

  const { query } = useParams()


  useEffect(() => {
    fetchAuthors();
    if (query) {
      fetchQuotes(1);
    }
  }, [query]);

  if(loading) {
    return (<div><Spinner/></div>)
  } else {
    return (
      <div>
        <div>
        {query ? 
          <div>
          <QuotesList
            quotes={quotes}
            total={total}
            totalPages={totalPages}
            perPage={perPage}
            currentPage={currentPage}
            fetchQuotes={fetchQuotes}
            loading={loading}
            query={query}
          />
          </div>
          :  
          <div className="relative flex-col text-center items-center">
          {allAuthors.map((author, index) => (
            <div key={index} className="mb-8 lg:mb-10 text-2xl md:text-5xl text-gray-800">
              <Link to={`/philosophers/${author}`}>
                <div className="flex justify-center my-2" >
                  <div className="w-16 lg:w-32 h-16 lg:h-32 overflow-hidden rounded-full">
                    {author === 'Marcus Aurelius' ? 
                    ( 
                      <img alt="Marcus Aurelius"
                      src="https://upload.wikimedia.org/wikipedia/commons/c/c5/Marcus_Aurelius_Metropolitan_Museum.png" />
                    )
                    :
                    (author === 'Seneca' ? 
                    ( 
                      <img alt="Seneca"
                      src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/b1/0_S%C3%A9n%C3%A8que_-_Mus%C3%A9e_du_Prado_-_Cat._144_-_%282%29.JPG/1024px-0_S%C3%A9n%C3%A8que_-_Mus%C3%A9e_du_Prado_-_Cat._144_-_%282%29.JPG" />
                    ) 
                    : 
                    ( 
                      <img alt="Epictetus"
                      src="https://upload.wikimedia.org/wikipedia/commons/9/90/Epictetus.jpg" />
                    ))}
                  </div>
                </div>
                <div className="font-bold italic hover:underline">
                  {author}
                </div>
              </Link>
            </div>
          ))}
          </div>
        }
        </div>
      </div>
    );
  }
};

export default Authors;
